import { render } from "./ToolDescriptionPageView.vue?vue&type=template&id=2f80c2a6&scoped=true"
import script from "./ToolDescriptionPageView.vue?vue&type=script&lang=js"
export * from "./ToolDescriptionPageView.vue?vue&type=script&lang=js"

import "./ToolDescriptionPageView.vue?vue&type=style&index=0&id=2f80c2a6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f80c2a6"]])

export default __exports__